import { render, staticRenderFns } from "./AddressCity.vue?vue&type=template&id=27551971&"
import script from "./AddressCity.vue?vue&type=script&lang=ts&"
export * from "./AddressCity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports